import React from "react";
import HeaderOpenData from "./HeaderOpenData";
import FooterOpenData from "./FooterOpenData";
import ListDataKategoriDetailDataOpenData from "./kategori/ListDataKategoriDetailDataOpenData";

const PagesKategoriDetailDataOpenData = ({formatDate})=>{
    
    return(
        <div>
            <ListDataKategoriDetailDataOpenData formatDate ={formatDate}/>
        </div>
    )
}

export default PagesKategoriDetailDataOpenData;